import { useTranslations } from 'next-intl';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { CatIconAdd } from 'blocks-nextjs/blocks-react/components/Icons/Add';
import { useDealerLocatorDrawer } from 'components/dealer-locator/dealer-locator-drawer-context';

export const AssociatedDealerAddDealerButton = () => {
  const t = useTranslations();
  const dealerLocatorDrawer = useDealerLocatorDrawer();

  return (
    <CatButton {...dealerLocatorDrawer?.initiatorProps} className="mt-3">
      {t('ADD_A_DEALER')}
      <CatIconAdd slot="before" />
    </CatButton>
  );
};
